// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"1cd31a9e","799":"cf570574","811":"2108dd54","992":"51600dd5"}[chunkId] + ".chunk.js";
};